export var TASK_TYPES_LABELS;
(function (TASK_TYPES_LABELS) {
    TASK_TYPES_LABELS["single-selection"] = "label.task_type.single_choice";
    TASK_TYPES_LABELS["multiple-selection"] = "label.task_type.multiple_choice";
    TASK_TYPES_LABELS["player-selection"] = "label.task_type.team_member_selection";
    TASK_TYPES_LABELS["text"] = "label.task_type.text_input";
    TASK_TYPES_LABELS["upload"] = "label.task_type.file_upload";
    TASK_TYPES_LABELS["location"] = "label.task_type.check_in";
    TASK_TYPES_LABELS["info"] = "label.task_type.information";
})(TASK_TYPES_LABELS || (TASK_TYPES_LABELS = {}));
